import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheckCircle, FaTrash, FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../../urls";
import axios from "axios";
import { CompanyContext } from "../../../../contexts/companyCotext";
import { LogisticContext } from "../../../../contexts/logisticContext";
import Loader from "../../../../components/loader";
import { IoIosWarning } from "react-icons/io";
import MessageAlert from "../../../../components/messageAlert";
import { OroderStatusHook } from "../../../../functions/updateOrodersStatus";
import hocStarredPage from "../../../../components/hocStarredPage";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { PlaySounds } from "../../../../functions/playSounds";
import { getDetectedOrderType } from "../../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../../axiosServer";

const Failedv2 = () => {
  const orderId = useRef(null);
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];
  const neworderId = useRef(null);
  const [stateLogistic, dispatchStateLogistic] = useContext(LogisticContext);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [numberofpackages, setNumberofpackages] = useState(null);
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [logisticSelect, setLogisticSelect] = useState(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [message, setMessage] = useState("S");
  const [showMessageErr, setShowMessageErr] = useState(false);
  const constNumPack = useRef(0);
  const [orderList, setOrdersList] = useState([]);
  const [orderStatus, setorderStatus] = useState("normal");
  const [OldOrderId, setOldOrderId] = useState(null);
  const [showPackageFlow, setShowPackageFlow] = useState(true);
  const [splitScanProgress, setSplitScanProgress] = useState(null);
  var host = window.location.host;

  let orderListCookies =
    Cookies.get("ordersHistory") === undefined
      ? []
      : JSON.parse(Cookies.get("ordersHistory"));
  var orderListVar = orderListCookies;

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  const syncPackageFlowVisibility = (value = "") => {
    const isSplitOrderId = value.trim().includes("-");
    setShowPackageFlow(!isSplitOrderId);

    if (isSplitOrderId) {
      setNumberofpackages(null);
      if (orderId.current) {
        orderId.current.value = "";
      }
    } else if (value.trim()) {
      setSplitScanProgress(null);
    }
  };

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (totalPackages || checkedPackages || remainingPackages) {
      setSplitScanProgress({
        totalPackages,
        checkedPackages,
        remainingPackages,
      });
    }
  };

  const fetchNbPackages = async (e) => {
    e.preventDefault();

    const order_id = neworderId.current.value.trim();
    const isSplitOrderId = order_id.includes("-");

    if (!order_id) {
      playErrorSound();
      setMessage("Please Enter First Order Id");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    neworderId.current.value = order_id;
    syncPackageFlowVisibility(order_id);

    let detectedOrderType = orderStatus;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(order_id);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setorderStatus(type);
    }

    let order_type;
     let o_type;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      order_type = detectedOrderType;
      o_type= detectedOrderType === "normal" ? "0" : "1";
    } else {
      order_type = orderStatus;
      o_type= orderStatus === "normal" ? "0" : "1"
    }

    try {
      const logistic = logisticSelect;
       let type;
       if (host === "pda.ishtari.com.gh") {
          type = "prepare_awaiting_failed";
        } else {
          type = "awaiting_failed";
        }

      if (isSplitOrderId) {
        const obj = {
          order_type,
          type,
          logistic_id: logistic,
          user_id: getUserIdFromLocalStorage(),
        };
        const isNormalOrder = order_type === "normal" || order_type === "0";

        if (isNormalOrder) {
          obj.order_id = order_id;
        } else {
          obj.return_order_id = order_id;
        }

        const url = buildLink(
          isNormalOrder ? "updateOrderV2" : "updateReturnOrderV2",
        );
        const response = await axiosServer.put(url, obj);
        const { success, message, data } = response.data || {};

        updateSplitScanProgress(response?.data?.package_scan ?? data);
        setMessage(message || "");
        neworderId.current.value = "";
        if (orderId.current) {
          orderId.current.value = "";
        }
        neworderId.current.focus();

        if (success) {
          const currentDate = new Date();
          const objtable = {
            date: format(currentDate, "dd-MM-yy HH:mm:ss"),
            user: stateCom.username,
            id: order_id.split("-")[0],
            status: data?.current_status || data?.data?.current_status || "",
            reason: message || "",
            success: true,
          };
          setOrdersList((prevProducts) => [objtable, ...prevProducts]);
          orderListVar.push(objtable);
          handleSetCookies(orderListVar);
          playSuccessSound();
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          playErrorSound();
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
        return;
      }

      const url =
        buildLink("getNbOfPackage") +
        `&order_id=${order_id}&order_type=${o_type}` +
        `&type=${type}&logistic=${logistic}`;

      const response = await axiosServer.get(url);

      const { success, message, data } = response.data || {};
      if (!success) {
        neworderId.current.value = "";
        playErrorSound();
        setMessage(message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      setLoading1(false);

      orderId.current.focus();

      const nb_of_package = Number(data?.nb_of_package ?? 0);
      constNumPack.current = nb_of_package;

      if (nb_of_package === 1) {
        orderId.current.value = order_id;
        setNumberofpackages(nb_of_package);

        const res = await updateOrderStatus(
          e,
          order_type,
          orderId.current.value,
          nb_of_package,
        );
        if (!res) {
          orderId.current.value = "";
          neworderId.current.value = "";
        } else {
          orderId.current.value = "";
          neworderId.current.value = "";
        }
        setLoading1(false);
        orderId.current.blur();
        neworderId.current.focus();
      } else if (nb_of_package > 1) {
        playSuccessSound();
        setMessage("Success");
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        setNumberofpackages(nb_of_package - 1);
        setLoading1(false);
      } else {
        playErrorSound();
        setMessage("Number Of Package is 0");
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    } catch (error) {
      neworderId.current.value = "";
      if (isSplitOrderId) {
        if (orderId.current) {
          orderId.current.value = "";
        }
        updateSplitScanProgress(
          error.response?.data?.package_scan ?? error.response?.data?.data,
        );
      }
      setLoading1(false);
      playErrorSound();
      setMessage(error.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      e.preventDefault();
    }
  };

  const handleTrashClickNewOrderId = () => {
    neworderId.current.value = "";
    setShowPackageFlow(true);
    setSplitScanProgress(null);
    neworderId.current.focus();
  };

  const updateOrderStatus = async (
    e = "",
    type = "",
    orderId = "",
    nb_of_package,
  ) => {
    const userID = getUserIdFromLocalStorage();
    const currentDate = new Date();
    const formattedDate = format(currentDate, "dd-MM-yy HH:mm:ss");
    e.preventDefault();

    let detectedOrderType = orderStatus;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(orderId);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setorderStatus(type);
    }

    let order_type;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      order_type = detectedOrderType;
    } else {
      order_type = orderStatus;
    }

    if (nb_of_package > 1) {
        setNumberofpackages(nb_of_package - 1);
        setOldOrderId(orderId);
    } else if (
      nb_of_package == 1
    ) {
      setLoading(true);
      const obj = {
        logistic_id: logisticSelect,
        user_id: userID,
        type: type,
        nb_of_pack: constNumPack.current,
        upc_id: "",
        item: "",
      };
      var url = "";
      if (order_type === "normal") {
        obj.order_id = orderId;
         if (host === "pda.ishtari.com.gh") {
          obj.type = "prepare_awaiting_failed";
        } else {
          obj.type = "awaiting_failed";
        }
        url = buildLink("updateOrder");
      } else {
        obj.return_order_id = orderId;
        if (host === "pda.ishtari.com.gh") {
          obj.type = "prepare_awaiting_failed";
        } else {
          obj.type = "awaiting_failed";
        }
        url = buildLink("updateReturnOrder");
      }

      setNumberofpackages(null);

      try {
        const response = await axiosServer.put(url, obj);

        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: orderId,
          status: response.data.data.current_status,
          reason: response.data.data.message,
          success: true,
        };
        setOrdersList((prevProducts) => [objtable, ...prevProducts]);

        if (response.data.success) {
          orderListVar.push(objtable);
          handleSetCookies(orderListVar);
          playSuccessSound();
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
          setLoading(false);
          handleTrashClickNewOrderId();

          return true;
        } else {
          orderListVar.push(objtable);
          handleSetCookies(orderListVar);
          playErrorSound();
          setMessage(response.data.message);
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
          setLoading(false);
          return true;
        }
      } catch (e) {
        setLoading(false);
        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: orderId,
          status: e.response.data.data.current_status,
          reason: e.response.data.message,
          success: false,
        };

        // Update orders list state immutably
        setOrdersList((prevProducts) => [...prevProducts, objtable]);
        setMessage(e.response.data.message);
        // Ensure we don't mutate the state variable directly
        const updatedOrderListVar = [...orderListVar, objtable];
        handleSetCookies(updatedOrderListVar);

        setLoading(false);

        setMessage(e.response.data.message);
        setShowMessageErr(true);
        playErrorSound();

        setTimeout(() => {
          setShowMessageErr(false);
        }, 10000);

        return false;
      }

      setLoading(false);
      setOldOrderId(null);
    }
  };

  const { setOrderList, handleRadioChange, handleSetCookies } =
    OroderStatusHook();

  const history = useNavigate();

  useEffect(() => {
    orderId.current.focus();
  }, []);

  const handleTrashClick = () => {
    orderId.current.focus();
    orderId.current.value = "";
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Prepare Awaiting Failed</h2>
            </div>
          </div>
        </div>
        <div className=" container">
          {host !== "pda.ishtari.com" &&
            !host.startsWith("localhost") &&
            host !== "pda.ishtari.com.gh" && (
              <div className=" py-3">
                <div>Order Type</div>
                <Select
                  placeholder="Order Type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      outline: "red",
                      padding: "8px 5px",
                    }),
                  }}
                  onChange={(e) => {
                    setorderStatus(e.value);
                  }}
                  options={options}
                />
              </div>
            )}
          <div className=" py-3">
            <div>Logistics</div>
            <Select
              placeholder="Logistics"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  outline: "red",
                  padding: "8px 5px",
                }),
              }}
              options={stateLogistic.logisticList}
              onChange={(e) => {
                setLogisticSelect(e.value);
              }}
            />

            <div className="mt-2">
                <div className="p-1">Order ID:</div>
                <form
                  onSubmit={(e) => fetchNbPackages(e)}
                  className="gap-2 flex "
                >
                  <div className="relative flex-1">
                    <input
                      ref={neworderId}
                      type="text"
                      onChange={(e) => syncPackageFlowVisibility(e.target.value)}
                      className="border-2 w-full rounded-md border-dbase px-[3px] py-2"
                    />
                    <FaTrash
                      className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                      onClick={handleTrashClickNewOrderId}
                    />
                  </div>
                  <div className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase">
                    <button className="flex  whitespace-nowrap  items-center justify-center h-full">
                      <FaSearch></FaSearch>
                    </button>
                  </div>
                </form>
            </div>

            {showPackageFlow ? (
              <>
                <div className="p-1 mt-2">Number of Packages:</div>
                <div className="space-x-3 flex flex-wrap">
                  <input
                    value={numberofpackages ?? ""}
                    readOnly
                    type="text"
                    className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Number of Packages"
                  />
                </div>
              </>
            ) : (
              splitScanProgress?.remainingPackages > 0 && (
                <>
                  <div className="p-1 mt-2">Scanned:</div>
                  <input
                    value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                    readOnly
                    type="text"
                    className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Scanned"
                  />
                </>
              )
            )}
          </div>
          {showPackageFlow && (
            <>
              <div className="-mt-2 -mb-2">Order ID</div>

              <form
            onSubmit={(e) => {
              e.preventDefault();
              if (
                host === "pda.ishtari.com.gh" ||
                host === "pda.energyplus-lb.com"
              ) {
                updateOrderStatus(
                  e,
                  "prepare_awaiting_failed",
                  orderId.current.value,
                  numberofpackages,
                );
                handleTrashClick();
              } else {
                updateOrderStatus(e, "awaiting_failed", orderId.current.value);
                handleTrashClick();
              }
            }}
            className="gap-2 flex py-3"
          >
            <div className="relative flex-1">
              <input
                ref={orderId}
                type="text"
                className="border-2 w-full rounded-md border-dbase py-2 pr-8 pl-2"
              />
              <FaTrash
                className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                onClick={() => handleTrashClick()}
              />
            </div>
            <button
              type="submit"
              className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase"
            >
              <div className="flex  whitespace-nowrap  items-center justify-center h-full">
                {numberofpackages > 1 || numberofpackages === 0 ? (
                  numberofpackages
                ) : loading ? (
                  <Loader />
                ) : (
                  "Mark as Failed"
                )}
              </div>
            </button>
              </form>
            </>
          )}
        </div>
        <div className="container w-full rounded-md text-white flex justify-between ">
          <div className="border w-full flex-1  px-8  text-dgreyBlack border-dblack  py-2 flex items-center justify-center">
            {orderList.length}
          </div>
          <div
            onClick={() => {
              setOrderList([]);
              setShowPackageFlow(true);
              setSplitScanProgress(null);
            }}
            className="border cursor-pointer w-full bg-dbase   flex-2  border-dblack  py-2 flex items-center justify-center"
          >
            Reset
          </div>
        </div>
        <div class="w-full mt-3 bg-white p-3 rounded container">
          <table class="w-full border-dlabelColor border">
            <thead>
              <tr className=" border-b border-dlabelColor">
                <th class="py-2  border-dlabelColor border-r">Order ID</th>
                <th class="py-2 border-r">Status</th>
                <th class="py-2 border-dlabelColor">Reason</th>
              </tr>
            </thead>
            <tbody>
              {orderList &&
                orderList.map((item) => {
                  return (
                    <tr
                      className={` ${
                        item.success ? "text-dgreen" : "text-dbase"
                      } text-center border-b border-dlabelColor`}
                    >
                      <td class="py-2  border-dlabelColor border-r">
                        {item.id}
                      </td>
                      <td class="py-2  border-dlabelColor border-r">
                        {item.status}
                      </td>
                      <td class="py-2  border-dlabelColor border-r">
                        {item.message}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <MessageAlert
          message={message}
          type={showMessageErr ? "err" : "succ"}
          showMessg={showMessageErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(Failedv2);
